// @owners { team: patient-fulfillment }
import { getIsOrderBundling } from '~shared/features/checkout/selectors/getCheckoutFlow';
import { getIsEditingExistingOrder } from '~shared/features/ui/selectors/getCart';
import { useSelectorShared } from '~shared/store';

export const useSaveOrderText = ({ isLastShipment }: { isLastShipment: boolean }): string => {
  const isEditingOrder = useSelectorShared(getIsEditingExistingOrder);
  const isOrderBundling = useSelectorShared(getIsOrderBundling);

  if (!isLastShipment) {
    return 'Continue to next delivery';
  } else if (isEditingOrder || isOrderBundling) {
    return 'Update order';
  } else {
    return 'Place order';
  }
};
